import DailySignalsTable from "./DailySignalsTable";
import { useSearchParams } from 'react-router-dom';

const Dashboard = ({ theme = 'light' }) => {
  const [searchParams] = useSearchParams();
  const sector = searchParams.get('sector') || '';
  const market = searchParams.get('market') || '';

  return (
    <div className="space-y-8">
      {/* Show only the individual stocks table here; pass initial filters from query params */}
      <DailySignalsTable
        signals={[]}
        theme={theme}
        showAggregate={false}
        showStocks={true}
        initialSelectedMarket={market || 'USALL'}
        initialSectorFilter={sector || undefined}
      />
    </div>
  );
};

export default Dashboard;